import React from 'react'

import { ZariContext } from '_zari/context'
import { Form } from '_zari/core'

import * as PresupuestoAsignacionService from 'services/presupuestoAsignacion.service'

const ImporteCell = ({ id, idProyecto, codigoPresupuesto, anoMes, importeBd, limpiarTotales }) => {
  const __zariContext = React.useContext(ZariContext)

  const [value, setValue] = React.useState(importeBd ?? '')
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const importeBaseRef = React.useRef(importeBd || 0)

  const onBlur = React.useCallback(() => {
    const innerValue = value || 0

    const parsedInnerValue = parseFloat(innerValue)
    if (isNaN(parsedInnerValue)) {
      __zariContext.toast('error', 'Valor incorrecto, no se pudo actualizar el registro.')
      return
    }

    if (parsedInnerValue === importeBaseRef.current) {
      return
    }

    setIsSubmitting(true)

    PresupuestoAsignacionService.nuevoActualizar({
      idProyecto: idProyecto,
      anoMes: anoMes,
      codigoPresupuesto: codigoPresupuesto,
      importe: parsedInnerValue
    })
      .then(() => {
        importeBaseRef.current = parsedInnerValue
        __zariContext.toast('success', 'El registro se ha actualizado.')
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        setIsSubmitting(false)
        limpiarTotales()
      })
  }, [__zariContext, value, idProyecto, anoMes, codigoPresupuesto, limpiarTotales])

  return (
    <td>
      <Form.InputNumber
        id={id}
        name={id}
        value={value}
        onChange={e => setValue(e.target.value)}
        disabled={isSubmitting}
        onBlur={onBlur}
      />
    </td>
  )
}

export default React.memo(ImporteCell)
